import { Mail } from 'lucide-react'
import { Item, ItemContent, ItemMedia, ItemTitle } from '@/components/ui/item'

type Props = {
  percentage: number
}

export const TriggerRow = ({ percentage }: Props) => (
  <Item variant="outline" size="sm">
    <ItemMedia variant="icon">
      <Mail />
    </ItemMedia>
    <ItemContent>
      <ItemTitle>{percentage}% usage alert</ItemTitle>
    </ItemContent>
  </Item>
)
